import { Person } from "./person";
import { BeneficiaryKey } from "./../Benefit/beneficiary-key";
import { Employee } from "./employee";
import { Card } from "./card";
import { Dependent } from "./dependent";
import { Company } from "../companies/company";

export class BeneficaryTemporaryLimit {
  beneficiaryId: string;
  newLimit: number;
  
}

export class Beneficiary extends Person {
  private active: boolean;
  private isHolder: boolean;
  private beneficiaryKey: BeneficiaryKey;
  private employee: Employee;
  private card: Card;
  private dependents: Dependent[] = [];
  private needValidateEmail: boolean;
  private enableDelivery: boolean;
  private parentBeneficiaryKey: BeneficiaryKey;
  private company: Company[] = [];
  private limit: number;
  private transactionPasswordRequired: boolean;
  private limitType: number;

  getLimitType() : number {
    return this.limitType
  }

  setLimitType(limitType: number) : void {
    this.limitType = limitType;
  }

  getTransactionPasswordRequired(): boolean {
    return this.transactionPasswordRequired;
  }
  setTransactionPasswordRequired(value: boolean): void {
    this.transactionPasswordRequired = value;
  }

  activateBeneficiary(): void {
    this.active = true;
  }

  inactivateBeneficiary(): void {
    this.active = false;
  }

  isActive(): boolean {
    return this.active;
  }

  setIsHolder(value: boolean): void {
    this.isHolder = value;
  }

  public getIsHolder(): boolean {
    return this.isHolder;
  }

  setBeneficiaryKey(value: BeneficiaryKey): void {
    this.beneficiaryKey = value;
  }

  public getBeneficiaryKey(): BeneficiaryKey {
    return this.beneficiaryKey;
  }

  setParentBeneficiaryKey(value: BeneficiaryKey): void {
    this.parentBeneficiaryKey = value;
  }

  public getParentBeneficiaryKey(): BeneficiaryKey {
    return this.parentBeneficiaryKey;
  }

  setEmployee(employee: Employee): void {
    this.employee = employee;
  }

  getEmployee(): Employee {
    return this.employee;
  }

  setCard(value: Card): void {
    this.card = value;
  }

  getCard(): Card {
    return this.card;
  }

  hasDependents(): boolean {
    return this.dependents.length > 0;
  }

  howManyDependents(): number {
    return this.dependents.length;
  }

  setDependents(dependents: Dependent[]): void {
    this.dependents = dependents;
  }

  getDependets(): Dependent[] {
    return this.dependents;
  }

  addDependent(dependent: Dependent): void {
    this.dependents.push(dependent);
  }

  isCardBlocked(): boolean {
    return this.card.getIsBlocked();
  }

  getNeedValidateEmail(): boolean {
    return this.needValidateEmail;
  }

  setNeedValidateEmail(value: boolean) {
    this.needValidateEmail = value;
  }

  getEnableDelivery(): boolean {
    return this.enableDelivery;
  }

  setEnableDelivery(value: boolean) {
    this.enableDelivery = value;
  }
  public getCompany(): Company[] {
    return this.company;
  }

  public setCompany(value: Company[]): void {
    this.company = value;
  }

  setLimit(value: number): void {
    this.limit = value;
  }

  getLimit(): number {
    return this.limit;
  }


 
}




